/**
 * Sign a paired kid into the auth store so role-aware UI (HomePage welcome,
 * assignments widget, navbar links) renders the student view instead of the
 * cached parent view.
 *
 * Device-authed requests still go through getAuthHeaders in the api-client,
 * which prefers the Device token stored under svara.device_tokens[studentId].
 * The empty-string token passed to authStore.login is intentional — it never
 * becomes an Authorization: Bearer header because the Device path takes
 * precedence, and setAuthToken skips falsy values.
 */
import { useAuthStore } from '@/features/auth/store/authStore';
import type { PairedStudent } from './deviceAuth';
import { setActiveStudentId } from './deviceAuth';

export function firstNameOf(s: PairedStudent): string {
  const name = s.display_name ?? '';
  const first = name.trim().split(/\s+/)[0];
  return first || 'Reader';
}

export function signInKid(student: PairedStudent): void {
  setActiveStudentId(student.id);
  useAuthStore.getState().login(
    {
      id: student.id,
      username: null,
      roles: ['student'],
      firstName: firstNameOf(student),
      lastName: null,
      studentId: student.id,
    },
    '',
  );
}
